import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";
import {
    useForm,
    useFetch,
    useGrid,
    useResource,
    usePopup,
    useStore,
    useToast,
    useAuth,
    useModal,
    useTab,
    usePage,
} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_SCHEMA_STSTCL_SELC,
    SG_STSTCL_SELC_TRDE,
    SF_BLL_STTS_RPRT,
    SG_BLL_STTS_RPRT,
} from "@/tz/go/egaz/osci/ststcl/lpco/service/OsciStstclSelcService";
import { MASK } from "@/tz/go/egaz/osci/lpco/comn/LpcoConstants";
/**
 * Report of bill per status !== 상태 별 고지서 ==!
 */
export const OSCI0502009Q = (props: any) => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0004", "auth_osci0019"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    // 전체 조회용 기관(OGAZ0037)이면 OGA 선택 가능 !== ==!
    const isAllOga = auth.get("orgCd") === "OGAZ0037";

    const [srchPrdDvnCd, setSrchPrdDvnCd] = useState("Y");
    const [bllSttsRprt, setBllSttsRprt] = useState(comnUtils.getGridData([]));
    // ORG LIST
    const [orgCdList, setOrgCdList] = useState([]);

    let errmsg: any;

    /*
     * Definition Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Statistics by Search Form !== HSCODE 통계 검색 Form ==!
        bllSttsRprt: useForm({
            defaultSchema: SF_BLL_STTS_RPRT,
            defaultValues: {
                ...(pgeStore?.form || {
                    srchPrdDvnCd: srchPrdDvnCd,
                    // 전체 조회용 기관(OGAZ0037)은 OGA를 공백으로 두어 전체 조회 !== ==!
                    orgCd: isAllOga ? "" : auth.get("orgCd"),
                    orgNm: isAllOga ? "" : auth.get("orgNm"),
                }),
            },
        }),
    };

    /*
     * Definition Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        bllSttsRprt: useGrid({
            defaultSchema: SG_BLL_STTS_RPRT,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        /* LPCO Component List !== LPCO Component 목록 ==! */
        getBllSttsRprt: useFetch({
            api: (page = grid.bllSttsRprt.page) => {
                return APIS.getBllSttsRprt(form.bllSttsRprt.getValues(), page, grid.bllSttsRprt.size);
            },
            enabled: comnUtils.isEmpty(form.bllSttsRprt.errors) && form.bllSttsRprt.isSubmitted,
            key: [grid.bllSttsRprt.page, grid.bllSttsRprt.size],
            onSuccess: (data: any) => {
                setStore(pgeUid, {
                    form: form.bllSttsRprt.getValues(),
                    page: grid.bllSttsRprt.page,
                    size: grid.bllSttsRprt.size,
                });

                // const bllSttsRprtContent = (data?.bllSttsRprt?.content || []).map((item: any) => ({
                //     ...item,
                //     sumAmt: (item.bllEqvAmt || 0) + (item.bllAmt || 0) + (item.prtlPaidAmt || 0),
                // }));

                // setBllSttsRprt(comnUtils.getGridData(bllSttsRprtContent));
                setBllSttsRprt(data?.bllSttsRprt || []);
                // if (srchPrdDvnCd == "Y") {
                //     grid.bllSttsRprt.setShow("column", "ststclYy", true);
                //     grid.bllSttsRprt.setShow("column", "ststclQrt", false);
                //     grid.bllSttsRprt.setShow("column", "ststclMm", false);
                // } else if (srchPrdDvnCd == "Q") {
                //     grid.bllSttsRprt.setShow("column", "ststclYy", true);
                //     grid.bllSttsRprt.setShow("column", "ststclQrt", true);
                //     grid.bllSttsRprt.setShow("column", "ststclMm", false);
                // } else if (srchPrdDvnCd == "M") {
                //     grid.bllSttsRprt.setShow("column", "ststclYy", true);
                //     grid.bllSttsRprt.setShow("column", "ststclQrt", false);
                //     grid.bllSttsRprt.setShow("column", "ststclMm", true);
                // } else if (srchPrdDvnCd == "C") {
                //     grid.bllSttsRprt.setShow("column", "ststclYy", false);
                //     grid.bllSttsRprt.setShow("column", "ststclQrt", false);
                //     grid.bllSttsRprt.setShow("column", "ststclMm", false);
                // }
            },
            onError: () => {},
            showToast: false,
        }),
        /* 통화별 집계(소계/총계) — 전체 데이터 기준 !== 통화별 집계 소계/총계 ==! */
        getBllSttsRprtSumm: useFetch({
            api: () => APIS.getBllSttsRprtSumm(form.bllSttsRprt.getValues()),
            // Fire with the list fetch, not only from the search button !== 목록과 같은 시점에 발화(검색 버튼 경유 외에도) ==!
            enabled: comnUtils.isEmpty(form.bllSttsRprt.errors) && form.bllSttsRprt.isSubmitted,
            onSuccess: (data: any) => {
                grid.bllSttsRprt.setSummary(Array.isArray(data) ? data : []);
            },
            onError: () => {},
            showToast: false,
        }),
    };

    const handler = {
        /* LPCO Component List !== LPCO Component 목록 ==! */
        getBllSttsRprt: () => {
            form.bllSttsRprt.handleSubmit(
                (data) => {
                    // Check before and after the date !== 날짜 앞뒤 체크 ==!
                    let startDt = "";
                    let endDt = "";
                    let focusName = "";
                    if (srchPrdDvnCd == "Y") {
                        startDt = form.bllSttsRprt.getValue("srchStrYear");
                        // endDt = form.bllSttsRprt.getValue("srchEndYear");

                        focusName = "srchEndYear";
                    } else if (srchPrdDvnCd == "Q") {
                        startDt = form.bllSttsRprt.getValue("srchStrQrtYy") + form.bllSttsRprt.getValue("srchStrQrt");
                        // endDt = form.bllSttsRprt.getValue("srchEndQrtYy") + form.bllSttsRprt.getValue("srchEndQrt");

                        focusName = "srchEndQrtYy";
                    } else if (srchPrdDvnCd == "M") {
                        startDt = form.bllSttsRprt.getValue("srchStrYmYy") + form.bllSttsRprt.getValue("srchStrYmMm");
                        // endDt = form.bllSttsRprt.getValue("srchEndYmYy") + form.bllSttsRprt.getValue("srchEndYmMm");

                        focusName = "srchEndYmYy";
                    } else if (srchPrdDvnCd == "C") {
                        startDt = form.bllSttsRprt.getValue("srchCustomStrtDt");
                        endDt = form.bllSttsRprt.getValue("srchCustomEndDt");

                        focusName = "srchCustomEndDt";
                    }
                    if (srchPrdDvnCd == "C" && endDt < startDt) {
                        modal.openModal({
                            content: "msg.osc.00081",
                        });
                        form.bllSttsRprt.setFocus(focusName);
                        return false;
                    }

                    grid.bllSttsRprt.setSummary(null);
                    grid.bllSttsRprt.setPage(0);
                    fetch.getBllSttsRprt.fetch(0);
                    fetch.getBllSttsRprtSumm.fetch();
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
        refreshOrgCdList: async () => {
            setOrgCdList((await lpcoUtils.getOrgCdList()) || []);
        },
        setInit: async () => {
            // !== 기관 목록 ==!
            handler.refreshOrgCdList();
        },
    };

    useEffect(() => {
        lpcoUtils.setSrchFormFromStore(form.bllSttsRprt, pgeStore);
        setSrchPrdDvnCd(form.bllSttsRprt.getValue("setSrchPrdDvnCd") || "Y");
        handler.setInit();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.bllSttsRprt.schema.orgCd} options={orgCdList} edit={isAllOga} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.bllSttsRprt.schema.srchCstmOfceCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.bllSttsRprt.schema.srchPrdDvnCd}
                                onChange={(v: any) => {
                                    console.log("v ", v);
                                    setSrchPrdDvnCd(v);
                                }}
                            />
                        </Group.Row>
                        {srchPrdDvnCd == "Y" && (
                            <Group.Row>
                                <Group.Control {...form.bllSttsRprt.schema.srchStrYear} />
                                {/* <Group.Control {...form.bllSttsRprt.schema.srchEndYear} /> */}
                            </Group.Row>
                        )}
                        {srchPrdDvnCd == "Q" && (
                            <Group.Row>
                                <Group.Label label={"L_QRT"} required={true}></Group.Label>
                                <Group.Col>
                                    <FormControl {...form.bllSttsRprt.schema.srchStrQrtYy} />
                                    <Group.Any>-</Group.Any>
                                    <FormControl {...form.bllSttsRprt.schema.srchStrQrt} />
                                </Group.Col>
                                {/* <Group.Label label={"L_END_QRT"} required={true}></Group.Label>
                                <Group.Col>
                                    <FormControl {...form.bllSttsRprt.schema.srchEndQrtYy} />
                                    <Group.Any>-</Group.Any>
                                    <FormControl {...form.bllSttsRprt.schema.srchEndQrt} />
                                </Group.Col> */}
                            </Group.Row>
                        )}
                        {srchPrdDvnCd == "M" && (
                            <Group.Row>
                                <Group.Label label={"L_MM"} required={true}></Group.Label>
                                <Group.Col>
                                    <FormControl {...form.bllSttsRprt.schema.srchStrYmYy} />
                                    <Group.Any>-</Group.Any>
                                    <FormControl {...form.bllSttsRprt.schema.srchStrYmMm} />
                                </Group.Col>
                                {/* <Group.Label label={"L_END_YM"} required={true}></Group.Label>
                                <Group.Col>
                                    <FormControl {...form.bllSttsRprt.schema.srchEndYmYy} />
                                    <Group.Any>-</Group.Any>
                                    <FormControl {...form.bllSttsRprt.schema.srchEndYmMm} />
                                </Group.Col> */}
                            </Group.Row>
                        )}
                        {srchPrdDvnCd == "C" && (
                            <Group.Row>
                                <Group.Control {...form.bllSttsRprt.schema.srchCustomRnge} />
                            </Group.Row>
                        )}
                        <Group.Row>
                            <Group.Control {...form.bllSttsRprt.schema.srchBllStatCd} controlSize={10} />
                        </Group.Row>
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="reset"
                                onClick={() => {
                                    form.bllSttsRprt.reset();
                                    // 조회 기간 구분은 화면 상태로 하위 입력을 제어하므로 함께 초기화한다.
                                    setSrchPrdDvnCd("Y");
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.getBllSttsRprt();
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="excelDown"
                                onClick={async () => {
                                    const bResult = await form.bllSttsRprt.validate();
                                    if (bResult) {
                                        // excel download
                                        lpcoUtils.saveExcelDownload(
                                            BASE.api + "/bll-stts-rprt/excel-down",
                                            form.bllSttsRprt.getValues(),
                                        );
                                    }
                                }}
                            />
                        </Layout.Left>
                    </Layout>

                    <Group.Section>
                        <Grid {...grid.bllSttsRprt.grid} data={bllSttsRprt} />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
